module.exports = __webpack_public_path__ + "static/base-5-6042fb6e3c3636eceb824f7522fb0b34.jpg";